import { Stack, Typography } from '@mui/material';

import { CounterStrip } from '@/components/shared/counterStrip';

interface ResourceSelectionManualViewerProps {
  include: string[];
  exclude: string[];
}

export const ResourceSelectionManualViewer = ({
  include,
  exclude,
}: ResourceSelectionManualViewerProps) => {
  return (
    <Stack width='100%' gap='24px'>
      <Typography variant='h4'>Manual override</Typography>
      <Stack gap={'12px'} width='240px'>
        <CounterStrip label='Include resources' count={include.length} />
        <CounterStrip label='Exclude resources' count={exclude.length} />
      </Stack>
    </Stack>
  );
};
